const topCntntEffect = (() => {
  if (document.querySelector("body#pageTop") !== null) {



    const secCntnt = document.querySelector('#jsSecCntnt');
    const cntntWrap = secCntnt.querySelector('.js-cntnt-wrap');
    const cntntAreas = cntntWrap.querySelectorAll('.js-cntnt-area');

    cntntAreas.forEach((element, index) => {

      let elem = element.querySelector('.js-effect')

      let intensity
      let image
      let displacement
      if (index == 0) {
        intensity = 0.3
        image = './assets/build/img/top/cntnt_1_img.jpg'
        // displacement = './assets/lib/hover-effect/displacement/8.jpg'
        // displacement = './assets/lib/hover-effect/displacement/7.jpg'
        // displacement = './assets/lib/hover-effect/displacement/4.png'
        displacement = './assets/lib/hover-effect/displacement/clouds.jpg'
      }
      if (index == 1) {
        intensity = 0.3
        image = './assets/build/img/top/cntnt_2_img.jpg'
        displacement = './assets/lib/hover-effect/displacement/10.jpg'
      }
      if (index == 2) {
        intensity = 0.2
        image = './assets/build/img/top/cntnt_3_img.jpg'
        // displacement = './assets/lib/hover-effect/displacement/4.png'
        displacement = './assets/lib/hover-effect/displacement/6.jpg'
      }

      let animation = new hoverEffect({
        parent: elem,
        intensity: intensity,
        image1: image,
        image2: image,
        displacementImage: displacement,
        speedIn: 1.6 * 1.6,
        speedOut: 1.2 * 1.6,
        hover: false,
        imagesRatio: 1280 / 1990,
      });



      let tl = gsap.timeline({
        scrollTrigger: {
          invalidateOnRefresh: true,
          trigger: elem,
          start: "0% 60%",
          // end: "50% 50%",
          onEnter: () => {
            setTimeout(() => {
              animation.next()
              // animation.previous()
            }, 650);
          },
          // onLeave: () => console.log("onLeave"),
          // onEnterBack: () => console.log("onEnterBack"),
          // onLeaveBack: () => animation.previous(),
          once: true,
          // markers: true,
        },
      })
      let target = document.querySelector('body');
      let observer = new ResizeObserver((entries) => {
        entries.forEach((entry) => {
          tl.scrollTrigger.refresh()
        });
      });
      observer.observe(target);


    });



  }
})()
export default topCntntEffect;